import React from 'react';
import styles from './SizingTools.module.scss';
import { FormControl, MenuItem, Select } from '@mui/material';
import { UnitDefinition } from '../../models/Api';
import UnitService from '../../services/UnitService';

export default function UnitPicker(props: {
  group: string;
  subGroup: number;
  value: string | null | undefined;
  changeHandler: (selectedUnit: string) => void;
  unitDefinitions?: UnitDefinition[];
}) {
  const { group, subGroup, unitDefinitions, value, changeHandler } = props;

  let filteredUnitDefinitions: UnitDefinition[] = [];

  if (unitDefinitions) {
    filteredUnitDefinitions = unitDefinitions;
  } else {
    filteredUnitDefinitions = UnitService.getFilteredUnits(group, subGroup);
  }

  return (
    <FormControl className={styles['unit-label-dropdown']} size="small">
      <Select
        color="secondary"
        name="unitPicker"
        value={value ?? ''}
        onChange={(e) => {
          changeHandler(e.target.value);
        }}
      >
        {filteredUnitDefinitions.map((unit) => (
          <MenuItem key={unit.unitLabel as string} value={unit.unitName as string}>
            {unit.unitLabel}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
